import { Slot } from "radix-ui";
import type { HTMLAttributes, ReactNode } from "react";

export interface MobileCardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title: ReactNode;
  /** Вторая строка: контрагент, дата, партия. */
  meta?: ReactNode;
  /** Число справа: количество, сумма. Не переносится. */
  value?: ReactNode;
  /** Статус под числом. */
  badge?: ReactNode;
  /** Карточка-ссылка или кнопка: элемент передаётся дочерним (Radix Slot). */
  asChild?: boolean;
}

/**
 * Карточка записи на телефоне. Название в две строки, а не обрезанное в
 * одну; число своей колонкой справа и не наезжает на название
 * (docs/ui-rules.md, «3»).
 */
export function MobileCard({ title, meta, value, badge, asChild, className, children, ...rest }: MobileCardProps) {
  const Comp = asChild ? Slot.Root : "article";
  const body = (
    <>
      <span className="w-mcard-title">{title}</span>
      {value !== undefined || badge ? (
        <span className="w-mcard-aside">
          {value !== undefined ? <span className="w-mcard-value">{value}</span> : null}
          {badge}
        </span>
      ) : null}
      {meta ? <span className="w-mcard-meta">{meta}</span> : null}
    </>
  );
  return (
    <Comp className={className ? `w-mcard ${className}` : "w-mcard"} {...rest}>
      {/* С asChild содержимое карточки встаёт внутрь пустого дочернего элемента. */}
      {asChild ? <Slot.Slottable>{children}</Slot.Slottable> : null}
      {body}
    </Comp>
  );
}
